/**
 * Dependencies
 */
import http from './HttpService'

/**
 * Query the API for a war room based on ID
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const getWarRoom = (id) => {
    return http.get(`war_rooms/${id}/`)
}

/**
 * Get the key/url for a downloadable file
 *
 * @param  {Number} warRoomId
 * @param  {Number} fileId
 * @return {Promise}
 */
export const getDownloadKey = (warRoomId, fileId) => {
    return http.post(`war_rooms/${warRoomId}/files/${fileId}/download/`)
}

/**
 * Delete an individual file in a war room
 *
 * @param  {Number} warRoomId
 * @param  {Number} fileId
 * @return {Promise}
 */
export const deleteFile = (warRoomId, fileId) => {
    return http.del(`war_rooms/${warRoomId}/files/${fileId}/`)
}

/**
 * Delete multiple files
 *
 * @param  {String} fileIds
 * @return {Promise}
 */
export const deleteMultipleFiles = (warRoomId, fileIds) => {
    return http.del(`war_rooms/${warRoomId}/files/?file_ids=${fileIds}`)
}

/**
 * Get a file by ID
 *
 * @param  {Number} warRoomId
 * @param  {Number} fileId
 * @return {Promise}
 */
export const getFile = (warRoomId, fileId) => {
    return http.get(`war_rooms/${warRoomId}/files/${fileId}/`)
}



// WEBPACK FOOTER //
// ./src/services/WarRoomService.js